export { Skeleton } from './Skeleton';
export {
  SkeletonProps,
  SkeletonContent,
  SkeletonContentType,
  SkeletonContentSize,
  SkeletonAlignment,
  SkeletonSpacing,
} from './Skeleton.types';
